//
import axios from "axios";
import { HOST } from "../../setting";

export const service = (id: number) =>
  axios.get(`${HOST}/master/kit-batch-list/${id}/`);
